import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=568d2acc&"
import script from "./Shift.vue?vue&type=script&lang=js&"
export * from "./Shift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports